import React from 'react';
import PropTypes from 'prop-types';
import MuiAvatar from '@material-ui/core/Avatar';
import { useAvatarStyles } from './avatarStyles';

/**
 * Default Avatar component based on https://material-ui.com/components/avatars/
 * @param {*} props All possible props can be found in docs https://material-ui.com/components/avatars/#api
 */
export default function Avatar(props) {
  const { children, ...rest } = props;
  const classes = useAvatarStyles();

  return (
    <MuiAvatar className={classes.default} {...rest}>
      {children}
    </MuiAvatar>
  );
}

Avatar.propTypes = {
  /**
   * Children
   */
  children: PropTypes.node,
};
